import { useEffect } from 'react'
import { useSnackbar } from 'notistack'

import { useNotificationsContext } from 'features/notifications/NotificationsProvider'

let displayed: any[] = []

export default function Notifier() {
  const { notifications, removeSnackbar } = useNotificationsContext()
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  function storeDisplayed(myKey: number | string) {
    displayed = [...displayed, myKey]
  }

  function removeDisplayed(myKey: number | string) {
    displayed = displayed.filter((key) => key !== myKey)
  }

  useEffect(() => {
    notifications.forEach(({ key, message, options, dismissed = false }) => {
      // dismiss snackbar using notistack
      if (dismissed) {
        closeSnackbar(key)
        return
      }

      // do nothing if snackbar is already displayed
      if (displayed.includes(key)) return

      // display snackbar using notistack
      enqueueSnackbar(message, {
        key,
        ...options,
        onExited: (_, myKey) => {
          // remove this snackbar from redux store
          removeSnackbar({ key: myKey })
          removeDisplayed(myKey)
        },
      })

      // keep track of snackbars that we've displayed
      storeDisplayed(key)
    })
  }, [notifications, closeSnackbar, enqueueSnackbar])

  return null
}
